"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDateRange = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_day_picker_1 = require("react-day-picker");
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../utils/dateTime");
const dateTimeFormat_1 = require("../../../utils/dateTimeFormat");
const locale_1 = require("../../../utils/locale");
const DayPicker_1 = require("../DayPicker");
const DayPickerFooter_1 = require("../DayPickerFooter");
const DayPickerWrapper_1 = require("../DayPickerWrapper");
require("./index.scss");
const mapToInput = (range) => {
    const from = range.from ? (0, moment_1.default)(range.from).format(dateTimeFormat_1.DATE_FORMAT) : undefined;
    const to = range.to ? (0, moment_1.default)(range.to).format(dateTimeFormat_1.DATE_FORMAT) : undefined;
    return {
        from,
        to,
    };
};
const mapToDate = (range, prevRange) => {
    const from = (0, moment_1.default)(range.from, dateTimeFormat_1.DATE_FORMAT);
    const to = (0, moment_1.default)(range.to, dateTimeFormat_1.DATE_FORMAT);
    return {
        from: from.isValid() ? from.toDate() : prevRange.from,
        to: to.isValid() ? to.toDate() : prevRange.to,
    };
};
class InputDateRangeClass extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.initState = () => {
            const { dateRange } = this.props;
            return {
                dateRange: mapToDate(dateRange, {}),
                dateFocusOn: this.props.dateClickInitBy,
                hoverRange: undefined,
            };
        };
        this.state = this.initState();
        this.handleDayClick = (day, modifiers) => {
            if (modifiers.disabled)
                return;
            const { dateFocusOn, dateRange } = this.state;
            const newDateRange = { ...dateRange };
            newDateRange[dateFocusOn] = day;
            const newDateFocusOn = dateFocusOn === 'from' ? 'to' : 'from';
            this.setState({
                dateRange: newDateRange,
                dateFocusOn: newDateFocusOn,
            }, () => {
                var _a, _b, _c, _d, _e, _f;
                const outDate = (0, moment_1.default)(day).format(dateTimeFormat_1.DATE_OUTPUT_FORMAT);
                if (dateFocusOn == 'from') {
                    (_b = (_a = this.props).onDateFrom) === null || _b === void 0 ? void 0 : _b.call(_a, outDate);
                }
                if (dateFocusOn == 'to') {
                    (_d = (_c = this.props).onDateTo) === null || _d === void 0 ? void 0 : _d.call(_c, outDate);
                }
                (_f = (_e = this.props).onDateRangeChange) === null || _f === void 0 ? void 0 : _f.call(_e, mapToInput(newDateRange), newDateFocusOn);
                if (newDateRange.from && newDateRange.to) {
                    this.props.onClose && this.props.onClose(mapToInput(newDateRange));
                }
            });
        };
        this.handleResetClick = () => {
            this.setState({ dateRange: {} }, () => {
                var _a, _b, _c, _d;
                (_b = (_a = this.props).onReset) === null || _b === void 0 ? void 0 : _b.call(_a);
                (_d = (_c = this.props).onDateRangeChange) === null || _d === void 0 ? void 0 : _d.call(_c, mapToInput({}), 'from');
            });
        };
        this.handleClose = () => {
            this.props.onClose && this.props.onClose(mapToInput(this.state.dateRange));
        };
        this.handleDayLeave = () => {
            this.setState({
                hoverRange: undefined,
            });
        };
        this.getHoverRange = (date, modifiers) => {
            const { dateClickInitBy } = this.props;
            const { dateRange } = this.state;
            if (modifiers.disabled)
                return dateRange;
            const newRange = { ...dateRange };
            newRange[dateClickInitBy] = date;
            return newRange;
        };
        this.handleDayEnter = (date, modifiers) => {
            this.setState({
                hoverRange: this.getHoverRange(date, modifiers),
            });
        };
    }
    componentDidUpdate(prevProps) {
        const prevFocus = prevProps.dateClickInitBy;
        const focus = this.props.dateClickInitBy;
        const prevRange = prevProps.dateRange;
        const range = this.props.dateRange;
        if (prevFocus !== focus || prevRange.from !== range.from || prevRange.to !== range.to) {
            this.setState({
                dateRange: mapToDate(range, this.state.dateRange),
                dateFocusOn: focus,
            });
        }
    }
    render() {
        var _a, _b;
        const { numberOfMonths, dateClickInitBy, restrictions } = this.props;
        const { hoverRange = {}, dateRange = {} } = this.state;
        const monthsDifference = numberOfMonths ? 1 - numberOfMonths : -1;
        const month = dateClickInitBy === 'to' && dateRange.to ? react_day_picker_1.DateUtils.addMonths(dateRange.to, monthsDifference) : dateRange.from;
        const range = {
            from: (_a = hoverRange.from) !== null && _a !== void 0 ? _a : dateRange.from,
            to: (_b = hoverRange.to) !== null && _b !== void 0 ? _b : dateRange.to,
        };
        const { from, to } = range;
        const calendarModifiers = {
            start: range.from,
            end: range.to,
        };
        return (react_1.default.createElement(DayPickerWrapper_1.DayPickerWrapper, null,
            react_1.default.createElement(DayPicker_1.DayPicker, { className: 'DayPicker--range', disabledDays: (0, dateTime_1.getDisabledDays)(restrictions), modifiers: calendarModifiers, numberOfMonths: numberOfMonths, onDayClick: this.handleDayClick, onDayMouseEnter: this.handleDayEnter, onDayMouseLeave: this.handleDayLeave, selectedDays: [from, to, { from, to }], month: month, locale: (0, locale_1.mapLocaleToLocaleCode)(this.props.intl.locale) }),
            react_1.default.createElement(DayPickerFooter_1.DayPickerFooter, { resetHidden: this.props.resetHidden || !(from || to), onClose: this.handleClose, onResetClick: this.handleResetClick })));
    }
}
InputDateRangeClass.defaultProps = {
    numberOfMonths: 2,
    onClose: () => {
    },
    onDateRangeChange: () => {
    },
    onOutsideClick: () => {
    },
    isEffectCloseAfterSelectActive: false,
};
exports.InputDateRange = (0, react_intl_1.injectIntl)(InputDateRangeClass);
//# sourceMappingURL=index.js.map